import React from 'react';
import PropTypes from 'prop-types';
import styles from './PagePanel.module.scss';

/* ────────────────────────────────────────────────────────────
 * PagePanel — elevated card that wraps the main content of a
 * page (a DataTable, a form, a detail view).
 *
 *   <PagePanel>
 *     <DataTable> ... </DataTable>
 *   </PagePanel>
 *
 * Padding default is `sm` so DataTable can sit flush against
 * the inner edge with its own internal scroll. Use `padding="md"`
 * or `"lg"` for forms / detail views that need breathing room.
 * Use `padding="none"` when the child renders its own padding.
 * ──────────────────────────────────────────────────────────── */

const PADDING_MAP = {
  none: styles.paddingNone,
  sm: styles.paddingSm,
  md: styles.paddingMd,
  lg: styles.paddingLg,
};

const PagePanel = ({ padding, children, className }) => {
  const panelClass = [
    styles.panel,
    PADDING_MAP[padding],
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return <section className={panelClass}>{children}</section>;
};

PagePanel.propTypes = {
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  children: PropTypes.node,
  className: PropTypes.string,
};

PagePanel.defaultProps = {
  padding: 'sm',
  children: null,
  className: '',
};

export default PagePanel;
